import { render, staticRenderFns } from "./LoadOrderTable.vue?vue&type=template&id=6955173b"
import script from "./LoadOrderTable.vue?vue&type=script&lang=js"
export * from "./LoadOrderTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports